import { useState, useEffect } from 'react';

import styles from './IFrame.css'

const IFrame = (props) => {
  const { onHide, isMobile } = props;
  const [height, setHeight] = useState("0");
  const [width, setWidth] = useState("0");

  useEffect(() => {
    window.addEventListener('message', handleEvent, false);
    return () => {
      window.removeEventListener('message', handleEvent); 
    }
  }, [])

  const handleEvent = event => {
    const { data } = event;

    if(data && data.setHeight) {
      setHeight(data.setHeight)
    }
    // if(data && data.setWidth) {
    //   setWidth(data.setWidth)
    // }

    if(data && data.closePopup) {
      onHide()
    }
  };

  return (
    <iframe
      className={ styles.iframe }
      style={{ height: isMobile ? '100%': `${height}px` }}
      width="800px"
      height={isMobile ? '100%' : height}
      id="rntr_learm-more-frame"
      scrolling={ isMobile ? "yes" : "no" }
      frameBorder="no"
      className="rntr_iframe" 
      src='https://app.revibecollection.com/static-assets/popup-black/html/main.html' 
    />
  )
}

export default IFrame;